import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { articleImage } from "@/lib/images";
import { ArrowLeft, Clock3 } from "lucide-react";

export default function Articolo() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/articles/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="container-site py-24 text-center" data-testid="articolo-not-found">
        <h1 className="text-3xl font-extrabold text-brand-ink">Articolo non trovato</h1>
        <Link to="/guide" className="btn-primary mt-8">Torna alle guide</Link>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="container-site py-24 text-center text-slate-500 font-semibold" data-testid="articolo-loading">
        Caricamento…
      </div>
    );
  }

  return (
    <article className="container-site py-16 lg:py-20 max-w-3xl" data-testid="articolo-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Link to="/guide" className="inline-flex items-center gap-2 font-bold text-brand-blue hover:gap-3 transition-all" data-testid="articolo-back-link">
          <ArrowLeft className="w-4 h-4" /> Tutte le guide
        </Link>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <span className="rounded-full bg-brand-mist text-brand-blue text-xs font-bold uppercase tracking-wider px-3 py-1.5" data-testid="articolo-category">
            {article.category}
          </span>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-400">
            <Clock3 className="w-4 h-4" /> {article.reading_min} min di lettura
          </span>
        </div>
        <h1 className="mt-5 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink leading-tight" data-testid="articolo-title">
          {article.title}
        </h1>
        <div className="mt-8 rounded-3xl overflow-hidden shadow-xl shadow-brand-blue/10" data-testid="articolo-image">
          <img src={articleImage(article.slug).url} alt={articleImage(article.slug).alt} loading="lazy" className="w-full h-72 object-cover" />
        </div>
        <div className="mt-8 space-y-5">
          {article.content.split("\n\n").map((p, i) => (
            <p key={i} className="text-lg text-slate-700 leading-relaxed">
              {p}
            </p>
          ))}
        </div>
        <div className="mt-12 rounded-3xl bg-brand-mist border border-brand-blue/10 p-8 text-center" data-testid="articolo-cta">
          <h2 className="text-xl font-extrabold text-brand-ink">Hai una situazione simile?</h2>
          <p className="mt-2 text-slate-600">
            Ogni caso è diverso. Raccontacelo: la prima consulenza è sempre gratuita.
          </p>
          <Link to="/assistenza" className="btn-primary mt-6" data-testid="articolo-cta-button">
            Richiedi assistenza gratuita
          </Link>
        </div>
      </motion.div>
    </article>
  );
}
